export default __webpack_public_path__ + "static/PromptIconThree-68fc9ff626d3c68ac221ee013794c07e.png";